<template>
  <div @scroll="handleScroll">
    <header class="header-principal">
      <a href="javascript:void(0)" class="holder-logo">
        <div class="logo">
          <img src="../../../assets/imgs/logo_vivo_ligado_amarelo_branco.png" alt />
        </div>
      </a>
      <transition name="fade">
        <div :class="scrolled ? 'fundo fundo-scroll' : 'fundo'"></div>
        <!-- <div class="fundo-scroll" :style="scrolled === true ? 'opacity: 100' : 'opacity: 0'"></div> -->
      </transition>
    </header>
  </div>
</template>

<script>
export default {
  name: 'HeaderShared',
  data() {
    return {
      scrolled: false,
    };
  },
  computed: {
    scrollHeader() {
      return this.rolagem;
    },
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 100;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

header {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-center;
  @extend %align-items-center;
  z-index: 10000;
  position: sticky;
  width: 100%;
  top: 0;
  padding: 5px 0px;
  transition: all 0.5s ease-in-out;
  margin-bottom: 50px;

  & .holder-logo {
    z-index: 10000;
  }

  & .logo img {
    @extend %flex;
    @extend %justify-center;
    @extend %align-items-center;
    width: 200px;
    height: 100%;
    margin-right: 20px;
  }
}

.fundo {
  @extend %gradiente_twilight;
  width: 100%;
  height: 100px;
  opacity: 1;
  top: 0;
  left: 0;
  position: absolute;
  z-index: -2;
}

.fundo-scroll {
  opacity: 0.99 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

@media all and (min-width: 300px) and (max-width: 1160px) {
  header {
    justify-content: space-between;
    padding: 15px 0px;
    max-width: 100vw;

    & .logo img {
      z-index: 50000;
      margin-left: 20px;
      width: 174px;
    }
  }

  .fundo-scroll {
    max-height: 75px;
  }

  .fundo {
    max-height: 75px;
  }
}

@media all and (min-width: 680px) and (max-width: 1160px) {
  header {
    justify-content: space-between;
    padding: 15px 0px;
    max-width: 100vw;

    & .logo img {
      margin-left: 40px;
      width: 280px;
    }
  }

  .fundo-scroll {
    max-height: 100px;
  }

  .fundo {
    max-height: 100px;
  }
}
</style>
